import { z } from 'zod';

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_STRIPE_PUBLISHABLE_KEY: z.string().optional(),
  VITE_APP_URL: z.string().url(),
  VITE_ENABLE_GEDCOM_IMPORT: z.string().optional(),
  VITE_ENABLE_PREMIUM: z.string().optional(),
  VITE_RECAPTCHA_SITE_KEY: z.string().min(1),
});

function validateEnv() {
  try {
    return envSchema.parse(import.meta.env);
  } catch (error) {
    console.error('❌ Invalid environment variables:', error);
    throw new Error('Invalid environment configuration. Check .env file.');
  }
}

export const env = validateEnv();

// Feature flags
export const FEATURES = {
  GEDCOM_IMPORT: env.VITE_ENABLE_GEDCOM_IMPORT === 'true',
  PREMIUM_PLANS: env.VITE_ENABLE_PREMIUM === 'true'
} as const;
